import InfoModel from './infoModel'
import * as Utils from '@/assets/script/utils'
import { CONSTANT } from '@/constant/index'

class ChatModel {
  constructor(option) {
    this.isLoading = false
    this.infos = []
  }

  /**
   * 增加聊天信息
   * @param {Object} config Info配置
   */
  add(config) {
    return new Promise(resolve => {
      const info = new InfoModel(config)
      this.infos.push(info)
      resolve(info)
    })
  }

  /**
   * 移除聊天信息
   * @param {String} id InfoId
   */
  remove(id) {
    this.isRemove = true
    this.infos.forEach((info, index) => {
      if (info.id === id) {
        this.infos.splice(index, 1)
      }
    })
  }

  /**
   * 清空聊天信息
   */
  clear() {
    this.infos = []
  }

  /**
   * 去重重复消息
   */
  unique() {
    const { infos } = this
    infos.forEach((info, index) => {
      if (index > 0 && info.title === infos[index - 1].title) {
        this.infos.splice(index, 1)
      }
    })
  }

  /**
   * 添加连接中动画
   * @param {function} callback 信息添加成功回调
   */
  showConnecting(callback) {
    this.connectInfo = new InfoModel({
      type: 'CONNECTING',
      title: CONSTANT.CONNECT_TIP,
      desc: CONSTANT.CONNECT_DESC
    })
    this.infos.push(this.connectInfo)
    callback && callback(this.connectInfo)
  }

  /**
   * 隐藏连接中动画
   */
  hideConnecting() {
    this.infos.forEach((info, index) => {
      if (info.id === this.connectInfo.id) {
        this.infos.splice(index, 1)
      }
    })
  }

  /**
   * 修改聊天信息标题
   * @param {Srtring} id 信息Id
   * @param {title} id 信息标题
   */
  setInfoTitle({ id, title, type, desc }) {
    this.infos.forEach(item => {
      if (item.id === id) {
        if (title) item.setTitle(title)
        if (type) item.setType(type)
        if (desc) item.setDesc(desc)
      }
    })
  }

  /**
   * 获取有图片的聊天记录
   */
  getInfosByImg() {
    return this.infos
      .filter(info => {
        const hasImg = /img\[([^\s]+?)\]/g.test(info.content),
          isType = info.type.search('IMAGE') > -1
        return hasImg || isType
      })
      .map(item => {
        const isArticle = item.type.search('ARTICLE') > -1,
          con = isArticle ? item.content : item.title
        return {
          id: item.id,
          url: con.replace(/(^img\[)|(\]$)/g, '')
        }
      })
  }

  /**
   * 消息设为已读
   * @param {string} ids 消息id集合
   */
  setRead(ids) {
    ids = ids.split(',')
    this.infos.forEach(info => {
      for (let i = 0; i < ids.length; i++) {
        if (ids[i] === info.id) {
          info.unread = false
        }
      }
    })
  }

  /**
   * 获取接收的info
   */
  getInfosByReceive() {
    let startIndex = 0
    for (let i = 0; i < this.infos.length; i++) {
      if (this.infos[i].title === CONSTANT.HISTORY_DIVIDING) {
        startIndex = i
      }
    }
    return this.infos.filter((info, index) => {
      const isType = Utils.checkType('RECEIVE & ARTIFICIAL', info.type),
        isUnAudio = !Utils.checkType('AUDIO', info.type),
        isNew = index > startIndex,
        isRead = info.unread
      return isType && isUnAudio && isNew && isRead
    })
  }

  /**
   * 设置加排队等待
   */
  setLoading(id, value) {
    const title = ' ',
      desc = CONSTANT.LOADING_TIP.replace(/{}/, value)
    this.setInfoTitle({ id, title, desc })
  }

  /**
   * 解析聊天内容（图片，表情，超链接）
   * @param {string} context
   */
  escape(context) {
    const reg = {
      face: /face\[([^\s\[\]]+?)\]/g,
      img: /img\[([^\s]+?)\]/g,
      // audio: /audio\([\s\S]+?\)\[([^\s]+?)\]/g,
      href: /a\([\s\S]+?\)\[[\s\S]*?\]/g
    }
    const _con = context
      .replace(reg.face, face => {
        //转义表情
        const alt = face.replace(/^face/g, '')
        return (
          '<img alt="' + alt + '" class="face" src="' + Utils.faces[alt] + '">'
        )
      })
      .replace(reg.img, img => {
        //转义图片
        return (
          '<img class="photo" type="image" src="' +
          img.replace(/(^img\[)|(\]$)/g, '') +
          '">'
        )
      })
      // .replace(reg.audio, (audio) => {
      //   const second = (audio.match(/audio\(([\s\S]+?)\)\[/) || [])[1]
      //   const href = (audio.match(/\)\[([\s\S]*?)\]/) || [])[1]

      //   //转义音频
      //   return (
      //     '<div class="audio"><span>' + second + '"</span><i>icon</i></div>'
      //   )
      // })
      .replace(reg.href, str => {
        //转义链接
        const href = (str.match(/a\(([\s\S]+?)\)\[/) || [])[1]
        const text = (str.match(/\)\[([\s\S]*?)\]/) || [])[1]
        if (!href) return str
        return (
          '<a class="link" href="' +
          href +
          '" target="_blank">' +
          (text || href) +
          '</a>'
        )
      })
    return _con
  }
}

export default ChatModel



// WEBPACK FOOTER //
// ./src/model/chatModel.js